export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8158.dcde3029.jpg";